import React from 'react';
import Header from '../../../components/header';
import Footer from '../../../components/footer';
import SEO from '../../../components/SEO';
import './vilkaar.css';

const Vilkaar = () => {
  return (
    <div className="vilkaar-page">
      <SEO 
        title="Handelsbetingelser | Parla Branding"
        description="Læs Parla Branding's handelsbetingelser for webdesign og SEO-tjenester. Klare vilkår for samarbejde, levering og kundeservice."
        url="https://www.parlabranding.dk/vilkaar"
        canonicalUrl="https://www.parlabranding.dk/vilkaar"
      />
      
      <Header />
      
      <main className="vilkaar-main">
        <div className="container">
          <div className="vilkaar-header">
            <h1>Handelsbetingelser</h1>
            <p className="vilkaar-updated">Sidst opdateret: 24. juli 2025</p>
          </div>

          <div className="vilkaar-content">
            <section className="vilkaar-section">
              <h2>Generelle bestemmelser</h2>
              <p>
                Disse handelsbetingelser gælder for alle aftaler mellem Parla Branding og vores kunder 
                vedrørende levering af webdesign, SEO-tjenester og relaterede digitale løsninger.
              </p>
              <div className="company-info">
                <p><strong>Parla Branding</strong></p>
                <p>København, Danmark</p>
                <p>E-mail: kontakt@parlabranding.dk</p>
                <p>Telefon: +45 36 17 00 00</p>
              </div>
            </section>

            <section className="vilkaar-section">
              <h2>Tjenester</h2>
              <p>Parla Branding tilbyder følgende hovedtjenester:</p>
              
              <div className="service-category">
                <h3>Webdesign og udvikling</h3>
                <ul>
                  <li>Responsive hjemmesider</li>
                  <li>Webshop-løsninger</li>
                  <li>Landing pages</li>
                  <li>Vedligeholdelse og opdateringer</li>
                </ul>
              </div>

              <div className="service-category">
                <h3>SEO-optimering</h3>
                <ul>
                  <li>Teknisk SEO audit</li>
                  <li>Keyword research og optimering</li>
                  <li>Content optimering</li>
                  <li>Link building</li>
                </ul>
              </div>

              <div className="service-category">
                <h3>Digital markedsføring</h3>
                <ul>
                  <li>Google Ads</li>
                  <li>Social media marketing</li>
                  <li>Content marketing</li>
                  <li>Analyser og rapportering</li>
                </ul>
              </div>
            </section>

            <section className="vilkaar-section">
              <h2>Priser og betaling</h2>
              
              <div className="terms-category">
                <h3>Prisfastsættelse</h3>
                <p>
                  Alle priser er angivet i danske kroner (DKK) inklusive moms, medmindre andet er angivet. 
                  Priserne er gældende på ordredatoen og kan ændres uden varsel for fremtidige ordrer.
                </p>
              </div>

              <div className="terms-category">
                <h3>Betalingsbetingelser</h3>
                <ul>
                  <li>Mindre projekter (under 25.000 kr.): 100% forudbetaling</li>
                  <li>Større projekter: 50% ved projektstart, 50% ved færdiggørelse</li>
                  <li>Løbende ydelser: Månedlig forudbetaling</li>
                  <li>Betalingsfrist: 14 dage fra fakturadato</li>
                </ul>
              </div>

              <div className="terms-category">
                <h3>Forsinket betaling</h3>
                <p>
                  Ved forsinket betaling påløber der renter efter renteloven samt et gebyr på 250 kr. 
                  Vi forbeholder os ret til at suspendere arbejdet ved manglende betaling.
                </p>
              </div>
            </section>

            <section className="vilkaar-section">
              <h2>Projektforløb og levering</h2>
              
              <div className="terms-category">
                <h3>Projektstart</h3>
                <p>
                  Projektet påbegyndes først efter modtagelse af underskrevet kontrakt og forudbetaling. 
                  Leveringstider regnes fra dette tidspunkt.
                </p>
              </div>

              <div className="terms-category">
                <h3>Kundens ansvar</h3>
                <ul>
                  <li>Levering af nødvendigt indhold (tekst, billeder, logoer)</li>
                  <li>Rettidig feedback på design og funktionalitet</li>
                  <li>Adgang til hosting og domæne når relevant</li>
                  <li>Godkendelse af milepæle inden for aftalte tidsfrister</li>
                </ul>
              </div>

              <div className="terms-category">
                <h3>Leveringstid</h3>
                <p>
                  Angivne leveringstider er vejledende og forudsætter rettidig levering af materiale fra kundens side. 
                  Forsinkelser grundet manglende input fra kunden forlænger leveringstiden tilsvarende.
                </p>
              </div>
            </section>

            <section className="vilkaar-section">
              <h2>Ændringer og revision</h2>
              
              <div className="terms-category">
                <h3>Inkluderede revisioner</h3>
                <p>
                  Alle projekter inkluderer et bestemt antal revisioner som angivet i tilbuddet. 
                  Mindre justeringer og bugfixes er altid inkluderet.
                </p>
              </div>

              <div className="terms-category">
                <h3>Ekstra arbejde</h3>
                <p>
                  Arbejde ud over det aftalte omfang faktureres separat til vores gældende timepriser. 
                  Større ændringer kræver skriftlig godkendelse før igangsættelse.
                </p>
              </div>

              <div className="terms-category">
                <h3>Funktionalitetsændringer</h3>
                <p>
                  Væsentlige ændringer i funktionalitet eller design efter projektstart kan medføre 
                  pristillæg og forlænget leveringstid.
                </p>
              </div>
            </section>

            <section className="vilkaar-section">
              <h2>Immaterielle rettigheder</h2>
              
              <div className="rights-category">
                <h3>Kundens rettigheder</h3>
                <p>
                  Kunden erhverver fuld ret til det færdige website/materiale efter fuld betaling. 
                  Dette inkluderer ret til at modificere, kopiere og distribuere indholdet.
                </p>
              </div>

              <div className="rights-category">
                <h3>Tredjepartskomponenter</h3>
                <p>
                  Visse komponenter (f.eks. plugins, skrifttyper) kan være underlagt separate licenser. 
                  Kunden er ansvarlig for overholdelse af disse licenser.
                </p>
              </div>

              <div className="rights-category">
                <h3>Porteføljerettigheder</h3>
                <p>
                  Parla Branding forbeholder sig ret til at bruge projektet som reference i vores portefølje 
                  og markedsføringsmateriale, medmindre andet aftales skriftligt.
                </p>
              </div>
            </section>

            <section className="vilkaar-section">
              <h2>Hosting og vedligeholdelse</h2>
              
              <div className="terms-category">
                <h3>Hosting-ansvar</h3>
                <p>
                  Medmindre andet er aftalt, er kunden ansvarlig for hosting af det færdige website. 
                  Vi kan assistere med hosting-anbefaling og opsætning mod særskilt betaling.
                </p>
              </div>

              <div className="terms-category">
                <h3>Vedligeholdelse</h3>
                <p>
                  Vi tilbyder vedligeholdelsesaftaler for løbende opdateringer, sikkerhed og support. 
                  Uden vedligeholdelsesaftale ydes support på timebasis.
                </p>
              </div>

              <div className="terms-category">
                <h3>Backup og sikkerhed</h3>
                <p>
                  Kunden er ansvarlig for regelmæssig backup af website og data. 
                  Parla Branding kan ikke holdes ansvarlig for datatab.
                </p>
              </div>
            </section>

            <section className="vilkaar-section">
              <h2>Garanti og ansvarsbegrænsning</h2>
              
              <div className="warranty-category">
                <h3>Funktionsgaranti</h3>
                <p>
                  Vi garanterer at det leverede arbejde fungerer som specificeret i 30 dage efter levering. 
                  Fejl og mangler rettes gratis inden for denne periode.
                </p>
              </div>

              <div className="warranty-category">
                <h3>Ansvarsbegrænsning</h3>
                <p>
                  Vores ansvar er begrænset til det beløb, der er betalt for den konkrete ydelse. 
                  Vi er ikke ansvarlige for indirekte tab, driftstab eller følgeskader.
                </p>
              </div>

              <div className="warranty-category">
                <h3>Force majeure</h3>
                <p>
                  Vi er ikke ansvarlige for forsinkelser eller manglende opfyldelse grundet forhold 
                  uden for vores kontrol, herunder naturkatastrofer, krig, eller tekniske nedbrud.
                </p>
              </div>
            </section>

            <section className="vilkaar-section">
              <h2>Fortrolighed</h2>
              <p>
                Vi behandler alle kundeoplysninger fortroligt og videregiver ikke information til tredjeparter 
                uden kundens samtykke, medmindre vi er lovpligtige hertil.
              </p>
              <div className="terms-category">
                <h3>NDA (Non-Disclosure Agreement)</h3>
                <p>
                  Ved særligt følsomme projekter kan der indgås separat fortrolighedsaftale efter ønske.
                </p>
              </div>
            </section>

            <section className="vilkaar-section">
              <h2>Opsigelse og afbestilling</h2>
              
              <div className="cancellation-category">
                <h3>Kundens opsigelse</h3>
                <ul>
                  <li>Projekter kan afbestilles mod betaling for udført arbejde</li>
                  <li>Løbende aftaler kan opsiges med 30 dages skriftligt varsel</li>
                  <li>Allerede betalte beløb refunderes ikke ved kundens afbestilling</li>
                </ul>
              </div>

              <div className="cancellation-category">
                <h3>Parla Brandings opsigelse</h3>
                <p>
                  Vi kan opsige aftalen ved kundens misligholdelse, herunder manglende betaling 
                  eller samarbejdsvanskeligheder. I sådanne tilfælde refunderes ikke-udført arbejde.
                </p>
              </div>
            </section>

            <section className="vilkaar-section">
              <h2>Klager og tvistløsning</h2>
              
              <div className="dispute-category">
                <h3>Reklamationsret</h3>
                <p>
                  Klager over det leverede arbejde skal fremsættes skriftligt inden for 14 dage 
                  efter levering. Vi stræber efter at løse alle klager hurtigt og tilfredsstillende.
                </p>
              </div>

              <div className="dispute-category">
                <h3>Lovvalg og værneting</h3>
                <p>
                  Aftalen er underlagt dansk ret. Eventuelle tvister søges løst ved forhandling. 
                  Hvis dette ikke lykkes, afgøres tvister ved danske domstole.
                </p>
              </div>
            </section>

            <section className="vilkaar-section">
              <h2>Kontakt</h2>
              <p>
                Ved spørgsmål til disse handelsbetingelser eller vores tjenester, er du velkommen til at kontakte os:
              </p>
              <div className="contact-info">
                <p><strong>E-mail:</strong> kontakt@parlabranding.dk</p>
                <p><strong>Telefon:</strong> +45 36 17 00 00</p>
                <p><strong>Adresse:</strong> København, Danmark</p>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Vilkaar;
